<div class="finance-payments-table py-4">
  <div class="mt-md-3 container-fluid">
    <div class="row">
      <!-- 100% del ancho disponible (a la derecha del sidebar) en todos los tamaños,
           para mostrar la mayor cantidad de columnas sin ocultar ni necesitar scroll. -->
      <div class="col-12">

  <!-- ============== Carga inicial ============== -->
  <div *ngIf="loadingInitial" class="text-center py-5">
    <div class="spinner-border text-primary" role="status"><span class="visually-hidden">Cargando...</span></div>
    <p class="mt-3 text-muted">Cargando pagos...</p>
  </div>

  <ng-container *ngIf="!loadingInitial">

  <!-- ============== Título ============== -->
  <div class="mb-3 d-flex align-items-center justify-content-between flex-wrap gap-2">
    <div>
      <h1 class="text-2xl font-bold text-gray-900 mb-0">
        <i class="fas fa-money-bill-wave text-blue-600 mr-2"></i> Pagos
      </h1>
      <p class="text-muted small mb-0">{{ total }} pago{{ total === 1 ? '' : 's' }} (vista tabla)</p>
    </div>
  </div>

  <!-- ============== Filtros de siempre (idénticos a la vista clásica) ============== -->
  <div class="row">
    <div class="col-12">

      <!-- Línea 1: Estatus (+ selector de periodo cuando es "Por conciliar") -->
      <div class="row align-items-end">
        <div class="mt-2 mb-2 col-12 col-md-5 col-lg-4">
          <div class="form-floating">
            <select (change)="onStatusChange()" [(ngModel)]="filter.type" class="form-select" id="floatingSelectStatus">
              <option value="all">Todos</option>
              <option value="p">Por conciliar</option>
              <option value="c">Conciliados</option>
              <option value="d">Devoluciones</option>
              <option value="a">Anulados / Transacción fallida</option>
              <option value="pc">En proceso de validación</option>
            </select>
            <label for="floatingSelectStatus">Estatus</label>
          </div>
        </div>

        <!-- Periodo: SOLO en "Por conciliar". Switch de 2 opciones (rango vs todo). -->
        <div class="mt-2 mb-2 col-12 col-md-auto" *ngIf="filter.type === 'p'">
          <div class="btn-group btn-group-sm" role="group" aria-label="Periodo de Por conciliar">
            <button type="button" class="btn"
                    [ngClass]="dateMode === 'range' ? 'btn-primary' : 'btn-outline-secondary'"
                    (click)="setDateMode('range')">
              <i class="fas fa-calendar-day me-1"></i> Rango de fechas
            </button>
            <button type="button" class="btn"
                    [ngClass]="dateMode === 'all' ? 'btn-primary' : 'btn-outline-secondary'"
                    (click)="setDateMode('all')">
              <i class="fas fa-infinity me-1"></i> Todo el histórico
            </button>
          </div>
        </div>
      </div>

      <!-- Línea 2: demás filtros (celdas uniformes) -->
      <div class="row">
        <!-- Rango de fecha: se oculta por completo en "Por conciliar + Todo el histórico" -->
        <div class="col-12 col-sm-6 col-lg-3 mt-2 mb-2" *ngIf="!(filter.type === 'p' && dateMode === 'all')">
          <input style="padding: 16px 9px; background: white;" id="demo-external-finance-table"
                 (onSet)="birthdaySet()" [(ngModel)]="range" mbsc-range class="form-control"
                 [mbsc-options]="dateSetting3" #externalRange="mobiscroll" />
        </div>

        <!-- Forma de pago -->
        <div class="mt-2 mb-2 col-12 col-sm-6 col-lg-3">
          <div class="form-floating">
            <select (change)="setFilter()" [(ngModel)]="filter.account" class="form-select" id="floatingSelectAccount">
              <option value="">Todos</option>
              <option *ngFor="let item of accounts; let i=index" [value]="item?.code">
                <span *ngIf="item?.bank">
                  {{item?.bank?.name}}{{item?.tag ? ' (' + item?.tag + ')' : ''}} ({{item?.payment_method?.name}})
                </span>
                <span *ngIf="!item?.bank">
                  {{item?.payment_method?.name}}{{item?.tag ? ' (' + item?.tag + ')' : item?.currency?.code ? ' (' + item?.currency?.code + ')' : ''}}
                </span>
                · {{item | empresaCuentaClase | uppercase}}
              </option>
            </select>
            <label for="floatingSelectAccount">Forma de pago</label>
          </div>
        </div>

        <!-- Sub estatus (solo "Por conciliar") -->
        <div class="mt-2 mb-2 col-12 col-sm-6 col-lg-3" [ngClass]="{'d-none': filter.type != 'p'}">
          <div class="form-floating">
            <select (change)="setFilter()" [(ngModel)]="filter.sub_status" class="form-select" id="floatingSelectSub">
              <option value="ALL">Todos</option>
              <option *ngFor="let item of list_payment_sub_status; let i=index" [value]="item?.code">
                {{item?.name}}
              </option>
            </select>
            <label for="floatingSelectSub">Sub estatus</label>
          </div>
        </div>

        <!-- Filtro múltiple de productos (idéntico a la vista clásica) -->
        <div class="mt-2 mb-2 col-12 col-sm-6 col-lg-3">
          <div class="position-relative product-search-input">
            <div class="form-floating">
              <input type="text" class="form-control" id="productSearchFinanceTable"
                     [(ngModel)]="productSearchTerm" (input)="filterProductsSearch()"
                     (focus)="openDropdown()" (click)="openDropdown()" [readonly]="!showDropdown"
                     placeholder="Buscar tipo de producto..." autocomplete="off">
              <label for="productSearchFinanceTable">
                <i class="fas fa-search me-2"></i> Buscar tipo de producto
              </label>
              <button type="button"
                      class="btn btn-sm btn-outline-secondary position-absolute end-0 top-50 translate-middle-y me-2"
                      *ngIf="productSearchTerm && (selectedProducts.length > 1 || (selectedProducts.length === 1 && selectedProducts[0] !== 'CREDIT'))"
                      (click)="clearProductSearch()" style="z-index: 10;">
                <i class="fas fa-times"></i>
              </button>
            </div>

            <div *ngIf="showDropdown"
                 class="dropdown-menu show position-absolute w-100 mt-2 shadow-lg border-0 filter-dropdown"
                 style="z-index: 1050;">
              <div class="px-3 py-2 bg-light border-bottom">
                <div class="d-flex align-items-center justify-content-between">
                  <small class="text-muted fw-medium">
                    <i class="fas fa-list me-1 text-primary"></i>
                    {{ filteredProductArray.length }} producto{{ filteredProductArray.length > 1 ? 's' : '' }} encontrado{{ filteredProductArray.length > 1 ? 's' : '' }}
                  </small>
                  <span class="badge bg-primary">{{ tempSelectedProducts.length }} seleccionado{{ tempSelectedProducts.length > 1 ? 's' : '' }}</span>
                </div>
              </div>

              <div class="filter-options" style="max-height: 300px; overflow-y: auto;">
                <div *ngIf="filterStates.isLoadingProducts" class="p-3">
                  <div *ngFor="let item of [1,2,3]" class="d-flex align-items-center mb-3">
                    <div class="placeholder-glow flex-grow-1"><span class="placeholder col-8"></span></div>
                  </div>
                </div>

                <div *ngIf="!filterStates.isLoadingProducts">
                  <div *ngFor="let item of filteredProductArray; trackBy: trackByProductCode"
                       class="filter-option-item px-3 py-3 border-bottom cursor-pointer"
                       [class.selected]="isProductSelected(item?.params?.code)"
                       (click)="onProductSelectionChange(item?.params?.code, !isProductSelected(item?.params?.code)); $event.stopPropagation()">
                    <div class="d-flex align-items-center">
                      <div class="me-3"><i class="fas fa-cube text-primary"></i></div>
                      <div class="flex-grow-1">
                        <div class="fw-medium text-dark">{{ item?.params?.name || item?.params?.code }}</div>
                        <small class="text-muted d-block">Código: {{ item?.params?.code }}</small>
                        <small class="text-muted d-block" *ngIf="item?.params?.dinamic_code && item?.params?.dinamic_code.length > 0">
                          Etiqueta: {{ item?.params?.dinamic_code[0] }}
                        </small>
                      </div>
                      <div *ngIf="isProductSelected(item?.params?.code)"><i class="fas fa-check text-primary fa-lg"></i></div>
                    </div>
                  </div>

                  <div *ngIf="filteredProductArray.length === 0" class="text-center py-4">
                    <i class="fas fa-search fa-3x text-muted mb-3"></i>
                    <h6 class="text-muted">No se encontraron productos</h6>
                    <p class="text-muted small">Intenta con otro término de búsqueda</p>
                  </div>
                </div>
              </div>

              <div class="px-3 py-3 bg-light border-top">
                <div class="d-flex align-items-center justify-content-between mb-3">
                  <small class="text-muted">
                    <i class="fas fa-info-circle text-primary me-1"></i>
                    {{ tempSelectedProducts.length }} de {{ productArray.length }} seleccionados
                  </small>
                  <button *ngIf="tempSelectedProducts.length > 1 || (tempSelectedProducts.length === 1 && tempSelectedProducts[0] !== 'CREDIT')"
                          type="button" class="btn btn-sm btn-outline-secondary" (click)="clearAllFilters()">
                    <i class="fas fa-times me-1"></i> Limpiar
                  </button>
                </div>
                <div class="d-flex gap-2">
                  <button type="button" class="btn btn-outline-secondary flex-fill" (click)="closeDropdown()"
                          [disabled]="filterStates.isApplyingFilter">Cancelar</button>
                  <button type="button" class="btn btn-primary flex-fill" (click)="applyFilters()"
                          [disabled]="filterStates.isApplyingFilter">
                    <span *ngIf="!filterStates.isApplyingFilter"><i class="fas fa-check me-1"></i> Aplicar</span>
                    <span *ngIf="filterStates.isApplyingFilter">
                      <div class="spinner-border spinner-border-sm me-2" role="status"></div> Aplicando...
                    </span>
                  </button>
                </div>
              </div>
            </div>

            <div *ngIf="filterStates.hasError" class="alert alert-danger mt-3" role="alert">
              <div class="d-flex align-items-start">
                <i class="fas fa-exclamation-triangle me-2 mt-1"></i>
                <div class="flex-grow-1">
                  <strong>Error en el filtro</strong>
                  <div class="small">{{ filterStates.errorMessage }}</div>
                  <button type="button" class="btn btn-sm btn-outline-danger mt-2" (click)="retryOperation()">
                    <i class="fas fa-redo me-1"></i> Reintentar
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- ===== BÚSQUEDA PUNTUAL (filtro de ACCIÓN: requiere presionar "Buscar") =====
             Se distingue a propósito de los filtros de arriba (que son instantáneos):
             fondo tintado, encabezado claro y botón "Buscar" como acción explícita. -->
        <div class="col-12 mt-2 mb-2">
          <div class="rounded finance-search-bar px-2 py-2"
               style="background:#eef4ff; border:1px solid #cfe0ff;">
            <div class="d-flex flex-wrap align-items-center gap-2">
              <span class="small fw-semibold text-primary me-1 text-nowrap">
                <i class="fas fa-search me-1"></i>Buscar pago
                <span class="text-secondary fw-normal d-none d-lg-inline">· presiona Buscar para aplicar</span>
              </span>

              <!-- Referencia -->
              <div class="input-group input-group-sm flex-fill" style="min-width: 200px; max-width: 300px;">
                <span class="input-group-text bg-white"><i class="fas fa-hashtag text-primary"></i></span>
                <input type="text" class="form-control" placeholder="Referencia (todo el histórico)"
                       [(ngModel)]="searchDraft.reference" (keyup.enter)="applySearch()" autocomplete="off">
              </div>

              <!-- Banco origen (de acción: NO auto-aplica) -->
              <div class="input-group input-group-sm" style="min-width: 175px; max-width: 220px;">
                <span class="input-group-text bg-white"><i class="fas fa-university text-primary"></i></span>
                <select class="form-select" [(ngModel)]="searchDraft.bank" (keyup.enter)="applySearch()">
                  <option value="">Banco origen: todos</option>
                  <option *ngFor="let b of bankList" [value]="b?.bankCode">{{ b?.name }}</option>
                </select>
              </div>

              <!-- Monto (rango USD) -->
              <div class="input-group input-group-sm" style="min-width: 180px; max-width: 220px;">
                <span class="input-group-text bg-white text-primary">$</span>
                <input type="number" class="form-control" placeholder="Mín"
                       [(ngModel)]="searchDraft.amount_min" (keyup.enter)="applySearch()">
                <span class="input-group-text bg-white px-1">—</span>
                <input type="number" class="form-control" placeholder="Máx"
                       [(ngModel)]="searchDraft.amount_max" (keyup.enter)="applySearch()">
              </div>

              <!-- Acciones: "Buscar" se resalta si hay cambios sin aplicar -->
              <button type="button" class="btn btn-sm text-nowrap"
                      [ngClass]="searchDirty ? 'btn-primary' : 'btn-outline-primary'"
                      (click)="applySearch()" [disabled]="loading || refTooShort">
                <i class="fas fa-search me-1"></i> Buscar
                <span *ngIf="searchDirty" class="ms-1" title="Cambios sin aplicar">●</span>
              </button>
              <button type="button" class="btn btn-sm btn-outline-secondary text-nowrap"
                      (click)="clearSearch()" [disabled]="loading || (!searchActive && !searchDirty)">
                <i class="fas fa-eraser me-1"></i> Limpiar
              </button>
            </div>

            <!-- Avisos contextuales (solo cuando aplican, para no ocupar alto fijo) -->
            <div class="small mt-1" *ngIf="refTooShort || refActive || searchDirty">
              <span *ngIf="refTooShort" class="text-danger"><i class="fas fa-exclamation-circle me-1"></i>Mínimo 6 caracteres.</span>
              <span *ngIf="refActive" class="text-primary"><i class="fas fa-search me-1"></i>Referencia exacta en <b>todo el histórico</b> (ignora fechas, estatus y producto).</span>
              <span *ngIf="searchDirty && !refTooShort && !refActive" class="text-secondary"><i class="fas fa-info-circle me-1"></i>Cambios sin aplicar — presiona <b>Buscar</b>.</span>
            </div>
          </div>
        </div>

        <!-- Controles de Ordenamiento -->
        <div class="col-12 mb-3">
          <div class="card border-0 sort-controls">
            <div class="card-body">
              <div class="row align-items-center">
                <div class="col-12">
                  <div class="d-flex align-items-center justify-content-end">
                    <div class="btn-group me-3" role="group">
                      <button type="button" class="btn btn-sm" [class.active]="sortOrder === 'desc'"
                              (click)="changeSortOrder('desc')" [disabled]="loading">
                        <i class="fas fa-sort-amount-down me-1"></i> Más Reciente
                      </button>
                      <button type="button" class="btn btn-sm" [class.active]="sortOrder === 'asc'"
                              (click)="changeSortOrder('asc')" [disabled]="loading">
                        <i class="fas fa-sort-amount-up me-1"></i> Más Antiguo
                      </button>
                    </div>
                    <div class="sort-info">
                      <i class="fas fa-info-circle"></i> {{getSortText()}} {{getSortIcon()}}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>

  <!-- ============== Tabla ============== -->
  <div class="bg-white rounded shadow-sm border position-relative">

    <div *ngIf="loading" class="fpt-loading-overlay">
      <div class="spinner-border text-primary" role="status"><span class="visually-hidden">Cargando...</span></div>
    </div>

    <!-- Vista tabla con todas las columnas. El contenedor se ensancha al achicar
         la pantalla (hasta 100%) para que quepan sin ocultar nada; por debajo de lg
         se reorganiza en tarjetas. -->
    <div class="fpt-table-wrap d-none d-lg-block">
      <table class="table table-hover align-middle mb-0 fpt-table">
        <thead>
          <tr>
            <th>Cliente</th>
            <th>Fechas</th>
            <th>Producto</th>
            <th>Banco origen / Destino</th>
            <th>Referencia</th>
            <th class="text-end">Monto</th>
            <th class="text-center">Estatus</th>
            <th *ngIf="verLiq">Liquidación al comercio</th>
            <th class="text-end">Acciones</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of rows; trackBy: trackByCode" class="fpt-row" (click)="openDetail(row)">
            <td>
              <div class="d-flex align-items-center gap-2 fpt-profile-link" (click)="goProfile(row, $event)" title="Ver perfil del cliente">
                <img class="fpt-avatar flex-shrink-0" [src]="avatarUrl(row)" alt="Avatar" />
                <div class="fpt-name-col">
                  <div class="fw-semibold fpt-ellipsis text-capitalize">{{ personName(row) }}</div>
                  <div class="text-muted fpt-xs fpt-ellipsis">{{ getIdentity(row) }}</div>
                  <!-- Morosidad: mora actual + mora efectiva (SOLO si ya pagó reactivación) -->
                  <div class="fpt-mora" *ngIf="moraActual(row) > 0 || (hasReactivation(row) && moraEfectiva(row) > 0)">
                    <span *ngIf="moraActual(row) > 0 && !(hasReactivation(row) && moraEfectiva(row) > 0)" class="fpt-mora-badge" [ngClass]="moraBadgeClass(moraActual(row))" title="Mora actual">
                      <i class="fas fa-exclamation-circle me-1"></i>{{ moraActual(row) }}d
                    </span>
                    <span *ngIf="hasReactivation(row) && moraEfectiva(row) > 0" class="fpt-mora-badge fpt-mora-efec" title="Mora efectiva (tras reactivación)">
                      <i class="fas fa-redo me-1"></i>{{ moraEfectiva(row) }}d
                    </span>
                  </div>
                </div>
              </div>
            </td>
            <td class="fpt-dates text-nowrap">
              <div>
                <span class="fpt-date-tag">Pago</span>
                <span class="fw-semibold">{{ (row?.payment?.register_payment_date || row?.payment?.date) | date:'dd/MM/yyyy' }}</span>
              </div>
              <div class="fpt-xs text-muted">
                <span class="fpt-date-tag">Reg.</span>{{ row?.payment?.date | date:'dd/MM/yyyy h:mm a' }}
              </div>
              <div class="fpt-xs text-muted" *ngIf="row?.payment?.reconciled_payment_date">
                <span class="fpt-date-tag">Concil.</span>{{ row?.payment?.reconciled_payment_date | date:'dd/MM/yyyy' }}
              </div>
            </td>
            <td>
              <span class="badge rounded-pill text-bg-light border">{{ row?.payment?.typeProduct || 'CREDIT' }}</span>
            </td>
            <td class="fpt-bank">
              <div class="fpt-ellipsis fpt-dest"
                   [ngbTooltip]="originTooltip(row)" tooltipClass="fpt-acc-tooltip" container="body" placement="top">
                <span class="fpt-bd-tag">Origen</span>
                <span class="fw-semibold">{{ bankName(row?.payment) }}</span>
                <i class="fas fa-info-circle text-primary fpt-xs ms-1"></i>
              </div>
              <div class="fpt-ellipsis fpt-dest mt-1"
                   [ngbTooltip]="destTooltip(row)" tooltipClass="fpt-acc-tooltip" container="body" placement="top">
                <span class="fpt-bd-tag">Destino</span>
                <span class="fw-semibold">{{ destLabel(row?.payment) }}</span>
                <i class="fas fa-info-circle text-primary fpt-xs ms-1"></i>
              </div>
            </td>
            <td>
              <span class="fpt-ref" [title]="row?.payment?.paymentMethodId || ''">{{ row?.payment?.paymentMethodId || '-' }}</span>
            </td>
            <td class="text-end text-nowrap">
              <div class="fw-semibold">{{ row?.payment?.amount | currency:'USD':'':'1.2-2' }} USD</div>
              <div class="text-muted fpt-xs" *ngIf="row?.payment?.counterValue">
                {{ row?.payment?.counterValue | number:'1.2-2' }} {{ row?.payment?.currency?.code || 'BS' }}
              </div>
              <div class="text-muted fpt-xs fpt-rate" *ngIf="row?.payment?.rate">
                USD 1 = BS {{ row?.payment?.rate | number:'1.2-2' }}
              </div>
            </td>
            <td class="text-center">
              <span class="badge rounded-pill" [ngClass]="getStatusClass(row?.payment)">{{ getStatusLabel(row?.payment) }}</span>
            </td>
            <!-- Liquidación al comercio (EST-03; maqueta escenario 5): tocarla abre la traza del pago en Consultas. -->
            <td *ngIf="verLiq" (click)="$event.stopPropagation()">
              <ng-container *ngIf="marcas[row?.payment?._id] as mk; else sinMarcafpt">
                <span class="mr-1 inline-flex items-center gap-1 align-middle"><app-estampa-comercio *ngFor="let c of (mk.comercios || [])" [codigo]="c" [tam]="20"></app-estampa-comercio></span>
                <a class="kb-badge !no-underline" [ngClass]="claseMarca(mk.estado)" [title]="mk.texto"
                   [routerLink]="mk.liquidacion ? null : ['/console/liquidacion/consultas']" [queryParams]="{ vista: 'buscar', pago: row?.payment?._id }"
                   (click)="mk.liquidacion && fichaLiq.abrir(mk.liquidacion)">{{ etiquetaPago(mk) }}</a>
              </ng-container>
              <ng-template #sinMarcafpt><span class="text-muted fpt-xs">—</span></ng-template>
            </td>
            <td class="text-end" (click)="$event.stopPropagation()">
              <ng-container *ngTemplateOutlet="actionsMenu; context: { row: row }"></ng-container>
            </td>
          </tr>

          <!-- Empty state -->
          <tr *ngIf="!loading && loaded && rows.length === 0">
            <td [attr.colspan]="verLiq ? 9 : 8" class="text-center text-muted py-5">
              <i class="fas fa-inbox fa-2x mb-2 d-block"></i>
              No se encontraron pagos con los filtros aplicados.
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Vista tarjetas: toda la info reorganizada verticalmente (no se oculta nada).
         Se usa por debajo de lg, donde la tabla ya no cabe ni a 100% de ancho. -->
    <div class="d-lg-none fpt-cards">
      <div class="fpt-card" *ngFor="let row of rows; trackBy: trackByCode" (click)="openDetail(row)">
        <div class="d-flex justify-content-between align-items-start gap-2">
          <div class="d-flex align-items-center gap-2 min-w-0 fpt-profile-link" (click)="goProfile(row, $event)" title="Ver perfil del cliente">
            <img class="fpt-avatar flex-shrink-0" [src]="avatarUrl(row)" alt="Avatar" />
            <div class="min-w-0">
              <div class="fw-semibold text-capitalize fpt-ellipsis">{{ personName(row) }}</div>
              <div class="text-muted fpt-xs fpt-ellipsis">{{ getIdentity(row) }}</div>
              <!-- Morosidad: mora actual + mora efectiva (SOLO si ya pagó reactivación) -->
              <div class="fpt-mora" *ngIf="moraActual(row) > 0 || (hasReactivation(row) && moraEfectiva(row) > 0)">
                <span *ngIf="moraActual(row) > 0 && !(hasReactivation(row) && moraEfectiva(row) > 0)" class="fpt-mora-badge" [ngClass]="moraBadgeClass(moraActual(row))" title="Mora actual">
                  <i class="fas fa-exclamation-circle me-1"></i>{{ moraActual(row) }}d
                </span>
                <span *ngIf="hasReactivation(row) && moraEfectiva(row) > 0" class="fpt-mora-badge fpt-mora-efec" title="Mora efectiva (tras reactivación)">
                  <i class="fas fa-redo me-1"></i>{{ moraEfectiva(row) }}d
                </span>
              </div>
            </div>
          </div>
          <div class="d-flex align-items-center gap-2 flex-shrink-0" (click)="$event.stopPropagation()">
            <span class="badge rounded-pill" [ngClass]="getStatusClass(row?.payment)">{{ getStatusLabel(row?.payment) }}</span>
            <ng-container *ngTemplateOutlet="actionsMenu; context: { row: row }"></ng-container>
          </div>
        </div>

        <div class="fpt-card-grid mt-2">
          <div>
            <div class="fpt-card-label">Monto</div>
            <div class="fw-semibold">{{ row?.payment?.amount | currency:'USD':'':'1.2-2' }} USD</div>
            <div class="text-muted fpt-xs" *ngIf="row?.payment?.counterValue">
              {{ row?.payment?.counterValue | number:'1.2-2' }} {{ row?.payment?.currency?.code || 'BS' }}
            </div>
            <div class="text-muted fpt-xs fpt-rate" *ngIf="row?.payment?.rate">
              USD 1 = BS {{ row?.payment?.rate | number:'1.2-2' }}
            </div>
          </div>
          <div>
            <div class="fpt-card-label">Fecha de pago</div>
            <div>{{ (row?.payment?.register_payment_date || row?.payment?.date) | date:'dd/MM/yyyy' }}</div>
            <div class="text-muted fpt-xs">Reg. {{ row?.payment?.date | date:'dd/MM/yyyy h:mm a' }}</div>
          </div>
          <div>
            <div class="fpt-card-label">Referencia</div>
            <div class="fpt-ref">{{ row?.payment?.paymentMethodId || '-' }}</div>
            <div class="text-muted fpt-xs">{{ row?.payment?.typeProduct || 'CREDIT' }}</div>
          </div>
          <div>
            <div class="fpt-card-label">Banco</div>
            <div class="fpt-xs text-truncate"><span class="fpt-bd-tag">Orig</span> {{ bankName(row?.payment) }}</div>
            <div class="fpt-xs text-truncate"><span class="fpt-bd-tag">Dest</span> {{ destLabel(row?.payment) }}</div>
          </div>
        </div>

        <div class="mt-2" *ngIf="verLiq && marcas[row?.payment?._id] as mk" (click)="$event.stopPropagation()">

          <div class="fpt-card-label">Liquidación al comercio</div>

          <span class="mr-1 inline-flex items-center gap-1 align-middle"><app-estampa-comercio *ngFor="let c of (mk.comercios || [])" [codigo]="c" [tam]="20"></app-estampa-comercio></span>
          <a class="kb-badge !no-underline" [ngClass]="claseMarca(mk.estado)" [title]="mk.texto"

             [routerLink]="mk.liquidacion ? null : ['/console/liquidacion/consultas']" [queryParams]="{ vista: 'buscar', pago: row?.payment?._id }"
                   (click)="mk.liquidacion && fichaLiq.abrir(mk.liquidacion)">{{ etiquetaPago(mk) }}</a>

        </div>

        <div class="text-center mt-2">
          <small class="text-primary"><i class="fas fa-hand-pointer me-1"></i>Toca para ver el detalle</small>
        </div>
      </div>

      <!-- Empty state móvil -->
      <div *ngIf="!loading && loaded && rows.length === 0" class="text-center text-muted py-5">
        <i class="fas fa-inbox fa-2x mb-2 d-block"></i>
        No se encontraron pagos con los filtros aplicados.
      </div>
    </div>

    <!-- ============== Paginación ============== -->
    <div class="d-flex align-items-center justify-content-between flex-wrap gap-2 px-3 py-2 border-top" *ngIf="loaded">
      <div class="d-flex align-items-center gap-3 flex-wrap">
        <div class="small text-secondary">Mostrando {{ rangeStart }}–{{ rangeEnd }} de {{ total }}</div>
        <div class="d-flex align-items-center gap-1 small text-secondary">
          <span>Mostrar</span>
          <select class="form-select form-select-sm w-auto" [ngModel]="limit" (ngModelChange)="changePageSize($event)">
            <option *ngFor="let s of pageSizeOptions" [ngValue]="s">{{ s }}</option>
          </select>
          <span>por página</span>
        </div>
      </div>
      <nav *ngIf="total > 0">
        <ul class="pagination pagination-sm mb-0">
          <li class="page-item" [class.disabled]="page === 1"><button class="page-link" (click)="goToPage(1)">«</button></li>
          <li class="page-item" [class.disabled]="page === 1"><button class="page-link" (click)="goToPage(page - 1)">‹</button></li>
          <li class="page-item" *ngFor="let p of pageNumbers" [class.active]="p === page">
            <button class="page-link" (click)="goToPage(p)">{{ p }}</button>
          </li>
          <li class="page-item" [class.disabled]="page === totalPages"><button class="page-link" (click)="goToPage(page + 1)">›</button></li>
          <li class="page-item" [class.disabled]="page === totalPages"><button class="page-link" (click)="goToPage(totalPages)">»</button></li>
        </ul>
      </nav>
    </div>

  </div>

  </ng-container>
      </div>
    </div>
  </div>
</div>

<!-- ============== Modal de detalle (reusa el componente clásico en modo modal) ============== -->
<ng-template #detailModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title"><i class="fas fa-receipt text-primary me-2"></i>Detalle del pago {{ selectedRow?.payment?.code }}</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body p-0">
    <app-person-payments [code_payment]="selectedRow?.payment?.code"
                         [code_person]="selectedRow?.payment?.owner?.code"></app-person-payments>
  </div>
</ng-template>

<!-- ============== Modal visor de comprobante (idéntico a la vista clásica) ============== -->
<ng-template #fileViewerModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title"><i class="fas fa-image me-2"></i>Comprobante de pago</h5>
    <button type="button" class="btn-close" (click)="closeFileModal()" aria-label="Close"></button>
  </div>
  <div class="modal-body text-center p-4" style="display: flex; align-items: center; justify-content: center; min-height: 400px;">
    <div *ngIf="selectedFileType === 'image'" class="image-container" style="width: 100%; display: flex; justify-content: center; align-items: center;">
      <img [src]="selectedFileUrl" alt="Comprobante de pago" class="img-fluid rounded shadow-sm"
           style="max-width: 100%; max-height: 70vh; object-fit: contain; display: block; margin: 0 auto;"
           (error)="selectedFileType = 'error'">
    </div>
    <div *ngIf="selectedFileType === 'error'" class="text-center">
      <i class="fas fa-exclamation-triangle text-warning" style="font-size: 3rem;"></i>
      <h5 class="mt-3">No se pudo cargar la imagen</h5>
      <p class="text-muted">La imagen no se puede visualizar en el navegador.</p>
      <a [href]="selectedFileUrl" target="_blank" class="btn btn-primary mt-2">
        <i class="fas fa-external-link-alt me-1"></i> Abrir en nueva pestaña
      </a>
    </div>
  </div>
  <div class="modal-footer justify-content-between">
    <button type="button" class="btn btn-primary" (click)="downloadCurrentFile()">
      <i class="fas fa-download me-1"></i> Descargar
    </button>
    <button type="button" class="btn btn-secondary" (click)="closeFileModal()">
      <i class="fas fa-times me-1"></i> Cerrar
    </button>
  </div>
</ng-template>

<!-- ============== Menú de acciones (reutilizado por tabla y tarjetas) ============== -->
<ng-template #actionsMenu let-row="row">
  <div ngbDropdown container="body" placement="bottom-end" class="d-inline-block">
    <button type="button" class="btn btn-sm btn-outline-secondary" ngbDropdownToggle title="Acciones">
      <i class="fas fa-ellipsis-v"></i>
    </button>
    <div ngbDropdownMenu>
      <button ngbDropdownItem (click)="openDetail(row)">
        <i class="fas fa-eye me-2 text-info"></i> Ver detalle
      </button>
      <button ngbDropdownItem *ngIf="row?.payment?.file" (click)="redirectIMG(row?.payment?.file, fileViewerModal)">
        <i class="fas fa-receipt me-2 text-secondary"></i> Ver comprobante
      </button>
      <button ngbDropdownItem *ngIf="canEdit() && !row?.payment?.reconciled_payment && row?.payment?.typeTransaction !== 'PENDING'"
              (click)="setPayment(row)">
        <i class="far fa-edit me-2 text-primary"></i> Editar
      </button>
      <ng-container *ngIf="canShowActions(row?.payment)">
        <button ngbDropdownItem *ngIf="canApprove()" [disabled]="loadcon" (click)="concilidarPago(row?.payment)">
          <i class="fas fa-check me-2 text-success"></i> Aprobar
        </button>
        <button ngbDropdownItem *ngIf="canCancel()" [disabled]="loadcon2" (click)="cancelPayment(row?.payment?.code)">
          <i class="fas fa-times me-2 text-danger"></i> Anular
        </button>
      </ng-container>
    </div>
  </div>
</ng-template>
